import { render } from "./ProfilePhotoSection.vue?vue&type=template&id=5fbd0dbd"
import script from "./ProfilePhotoSection.vue?vue&type=script&lang=js"
export * from "./ProfilePhotoSection.vue?vue&type=script&lang=js"
script.render = render

export default script